import '../css/CareersPageComponent.scss';
import BannerComponent from './BannerComponent';
import CareerImage from '../assets/carrer.jpeg';
import { Link } from 'react-router-dom';
import { FiBookOpen, FiHeart, FiAward, FiUsers, FiMail } from 'react-icons/fi';

const openRoles = [
  {
    title: 'Primary School Teachers',
    type: 'Year 1 – 6',
    description:
      'Deliver engaging, high-quality lessons across the primary curriculum to pupils in Years 1–6, maintaining the highest academic standards in a nurturing classroom environment.',
  },
  {
    title: 'Preschool Teachers',
    type: 'EYFS',
    description:
      'Provide a warm, stimulating early-years experience for our youngest learners, following the EYFS framework and fostering curiosity, play and foundational skills.',
  },
  {
    title: 'Subject Specialists',
    type: 'Yoruba & English',
    description:
      'Teach Yoruba and/or English as specialist subjects, bringing deep subject knowledge and a passion for language, literacy and cultural appreciation.',
  },
];

const perks = [
  { icon: <FiBookOpen />, title: 'Continuous Training', body: 'Regular local and international professional development to keep you at the forefront of modern education.' },
  { icon: <FiHeart />, title: 'Faith-Centred Culture', body: 'Work in an environment rooted in Christian values, where integrity, respect and love guide every interaction.' },
  { icon: <FiAward />, title: 'Excellence Recognised', body: 'Outstanding performance is celebrated and rewarded — we invest in people who invest in our pupils.' },
  { icon: <FiUsers />, title: 'Collaborative Team', body: 'Join a close-knit staff community where ideas are shared, support is given freely, and everyone grows together.' },
];

const CareersPageComponent = () => (
  <div>
    <BannerComponent
      title="Careers at HoneyRock"
      image={CareerImage}
      description="Join a team of passionate educators dedicated to shaping tomorrow's leaders."
      buttonInformation={<></>}
    />

    <div className="page-width">

      {/* Intro */}
      <section className="careers-intro">
        <span className="careers-section-kicker">Why HoneyRock?</span>
        <h2>More Than a Job — a Calling</h2>
        <p>
          At The HoneyRock School, every member of staff plays a vital role in the lives of our
          pupils. We are committed to building not just great learners, but great human beings — and
          that starts with a great team. If you are passionate, purposeful, and ready to make a
          lasting difference, we'd love to hear from you.
        </p>
      </section>

      {/* Perks */}
      <section className="careers-perks">
        {perks.map(p => (
          <div key={p.title} className="careers-perk-card">
            <div className="perk-icon">{p.icon}</div>
            <h3>{p.title}</h3>
            <p>{p.body}</p>
          </div>
        ))}
      </section>

      {/* Open roles */}
      <section className="careers-roles">
        <span className="careers-section-kicker">Current Openings</span>
        <h2>Open Positions</h2>
        <p className="careers-roles-sub">
          All applicants must meet the following requirements: minimum NCE / Bachelor's degree in
          Education or a related field; proven experience with the Nigeria / British Curriculum;
          strong communication skills and teaching pedagogy; classroom management skills; and a
          passion for child development and inclusive education.
        </p>

        <div className="roles-grid">
          {openRoles.map(role => (
            <div key={role.title} className="role-card">
              <div className="role-card-top">
                <h3>{role.title}</h3>
                <span className="role-type">{role.type}</span>
              </div>
              <p>{role.description}</p>
              <a
                href="mailto:career@thehoneyrockschool.com?subject=Job Application"
                className="role-apply-btn"
              >
                Apply Now
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* Speculative CTA */}
      <section className="careers-cta">
        <FiMail className="cta-icon" />
        <h2>Don't See Your Role?</h2>
        <p>
          We welcome speculative applications from dedicated professionals who share our values.
          Send your CV and a short cover letter to us and we'll be in touch.
        </p>
        <a
          href="mailto:career@thehoneyrockschool.com?subject=Speculative Application"
          className="careers-teaser-btn"
        >
          Send Your CV
        </a>
      </section>

    </div>
  </div>
);

export default CareersPageComponent;
